import React, { useState } from "react";
import styled from "styled-components";
import {
  Container,
  CommonSection,
  CommonTitle,
  CommonSubTitle,
  H3Title,
} from "../../common/styles";

const Qualification = () => {
  const [isActive, setIsActive] = useState(true);

  const handleSetActiveExp = () => {
    setIsActive(true);
  };

  const handleSetActiveEdu = () => {
    setIsActive(false);
  };

  return (
    <CommonSection id="portfolio">
      <CommonTitle>Qualification</CommonTitle>
      <CommonSubTitle>My personel journey</CommonSubTitle>

      <QualificationContainer>
        <QualificationTab>
          <ButtonLink isActive={isActive} onClick={handleSetActiveExp}>
            <i className="uil uil-briefcase-alt"></i>
            Experience
          </ButtonLink>
          <ButtonLink isActive={!isActive} onClick={handleSetActiveEdu}>
            <i className="uil uil-graduation-cap"></i>
            Education
          </ButtonLink>
        </QualificationTab>

        <QualificationSections>

          {isActive ?
            <QualificationContentExp isActive={isActive}>
              <QualificationData>
                <div>
                  <H3Title>Full-stack Blockchain Developer</H3Title>
                  <QualificationSubTitle>
                    Fragments
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> MAy 2022 - Present
                  </QualificationCalendar>
                </div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>
              </QualificationData>

              <QualificationData>
                <div></div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>

                <div>
                  <H3Title>AutoPay</H3Title>
                  <QualificationSubTitle>
                    Full stack Blockchain Developer
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> Dec 2022 - present
                  </QualificationCalendar>
                </div>
              </QualificationData>

              <QualificationData>
                <div>
                  <H3Title>Webmaster</H3Title>
                  <QualificationSubTitle>
                    Executive Student Committee, AIChE
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> May 2021 - 2022
                  </QualificationCalendar>
                </div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>
              </QualificationData>
            </QualificationContentExp>
            :
            <QualificationContentEdu isActive={!isActive}>
              <QualificationData>
                <div>
                  <H3Title>Chemical Engineering</H3Title>
                  <QualificationSubTitle>
                    National Institute of Technology, Rourkela
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> Dec 2020 - May 2024
                  </QualificationCalendar>
                </div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>
              </QualificationData>

              <QualificationData>
                <div></div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>

                <div>
                  <H3Title>Ethereum Bootcamp</H3Title>
                  <QualificationSubTitle>
                    Alchemy University
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> Dec 2022 - Present
                  </QualificationCalendar>
                </div>
              </QualificationData>

              <QualificationData>
                <div>
                  <H3Title>Science</H3Title>
                  <QualificationSubTitle>
                    Khallikote Junior College
                  </QualificationSubTitle>
                  <QualificationCalendar>
                    <i className="uil uil-calender"></i> 2018 - 2020
                  </QualificationCalendar>
                </div>

                <div>
                  <QualificationRounder></QualificationRounder>
                  <QualificationLine></QualificationLine>
                </div>
              </QualificationData>


            </QualificationContentEdu>
          }
        </QualificationSections>
      </QualificationContainer>
    </CommonSection>
  );
};

export default Qualification;

const QualificationContainer = styled(Container)`
  max-width: 768px;
`;

const QualificationTab = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

const ButtonLink = styled.div`
  .uil {
    margin-right: 0.5rem;
    font-size: 1.8rem;
    font-weight: 500;
  }
  color: #333333;
  margin: 1rem;
  border-bottom:${({ isActive }) => (isActive ? "2px solid black" : "none")}; ;
  cursor: pointer;
  :hover {
    color: #000000;
  }
  @media screen and (max-width: 576px) {
    margin: 0 0.75rem;
  }
`;

const QualificationSections = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

const QualificationContentEdu = styled.div`
  animation: ${({ isActive }) => (isActive ? "fadein 2s ease-in-out" : "none")};
  display: ${({ isActive }) => (isActive ? "block" : "none")};
`;

const QualificationContentExp = styled.div`
  animation: ${({ isActive }) =>
    !isActive ? "fadein 2s ease-in-out" : "none"};
  @keyframes fadein {
    0% {
      display: none;
      opacity: 0;
    }

    1% {
      display: block;
      opacity: 0;
    }

    30% {
      display: block;
      opacity: 1;
    }
  }
  display: "block";

  transition: all 0.2s ease-in-out;
`;

const QualificationData = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  column-gap: 3.5rem;

  @media screen and (max-width: 443px) {
    column-gap: 2rem;
  }

  @media screen and (max-width: 396px) {
    column-gap: 0.5rem;
  }
`;

const QualificationSubTitle = styled.span`
  display: inline-block;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
`;

const QualificationCalendar = styled.div`
  font-size: 0.875rem;
`;

const QualificationRounder = styled.span`
  display: inline-block;
  width: 13px;
  height: 13px;
  background-color: #757575;
  border-radius: 50%;
`;

const QualificationLine = styled.span`
  display: block;
  width: 1px;
  height: 100%;
  background-color: #757575;
  transform: translate(6px, -7px);
`;
